<template>
  <div class="list">
    <div class="list-detail-container">
      <div class="articleList">
        <div class="title">{{ list.title }}</div>
        <div class="vice_title">{{ list.vice_title }}</div>
        <div
          v-html="list.content"
          style="width: 900px; padding: 0px 50px"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import Bread from "./Bread.vue";
export default {
  components: {
    Bread,
  },
  name: "Contents",
  watch: {
    // 监听路由发生改变
    $route: {
      immediate: true,
      handler(newVal) {
        console.log(`Artice`, newVal.query.id);
        this.getMenu();
        this.id = newVal.query.id || "";
        // this.getInfo(ucode);
      },
    },
    id(val) {
      // console.log(`Articeid`, val);
    },
    ucode(val) {
      // console.log(`Articeucode`, val);
    },
  },
  props: {
    // ucode: {
    //   type: String,
    //   default: "",
    //   required: false,
    // },
  },
  created() {
    this.getMenu();
    // this.ucode = this.$route.query.ucode
  },
  data() {
    return {
      id: "",
      list: [],
    };
  },
  methods: {
    getMenu() {
      let url = `${window._CONFIG["domianURL"]}xmu/index/menu`;
      this.$axios({
        method: "get",
        url: url,
      }).then((res) => {
        this.menuList = res.data.result;
        let arrs = this.menuList.find(
          (element) => element.menuName == this.$route.query.title.toUpperCase()
        );
        // this.childList = arrs.childList;
        let str = arrs.childList.find(
          (c) => c.menuName == this.$route.query.name
        );
        if (str) {
          this.id = str.apiAddr;
        }
        this.getInfo(this.id);
      });
    },
    getInfo(id) {
      if (this.$route.query.id) {
        let query = this.$route.query.id;
        console.log(`this.id`, this.id);
        console.log(`query`, this.$route.query.id);
        let n = query.indexOf("4c395100b9994e7cb2880cf70327dc69/");
         if (n != -1) {
        id = this.$route.query.id;
      } else {
        if (this.$route.query.id) {
          // id = this.id;
          id = `36261a89badc4e0dbac011fcd18a6864/`+query;
        }
      }
      }
      let url = `${window._CONFIG["domianURL"]}xmu/index/form/${id}`;
      this.$axios({
        method: "get",
        url: url,
      }).then((res) => {
        let data = res.data.result;
        this.list = data;
        console.log("Artice list", this.list.title);
      });
    },
  },
};
</script>

<style lang="less" scoped>
header {
  background-color: rgb(0 0 0 / 10%);
}
.list-detail-container {
  padding: 15px 100px 15px 100px;
}
.articleList {
  margin: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-size: 30px;
  font-family: Adobe Heiti Std;
  font-weight: bold;
  color: #000000;
  line-height: 40px;
}
.vice_title {
  margin-top: 10px;
  width: 100%;
  text-align: center;
  font-size: 22px;
  font-family: Adobe Heiti Std;
  color: #000000;
  line-height: 30px;
}

.year {
  font-size: 16px;
  font-family: Adobe Heiti Std;
  font-weight: bold;
  color: #757575;
  line-height: 30px;
  text-align: center;
}
.content {
  font-size: 18px;
  font-family: Alibaba Sans;
  font-weight: 400;
  color: #000000;
}
.list {
  margin: 0 190px 15px 190px;
  padding-bottom: 25px;
  position: relative;
  margin-bottom: 10px;
  border: 1px solid #e6e6e6;
  box-shadow: 2px 6px 8px 0px rgba(32, 32, 32, 0.13);
  position: relative;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}
.img {
  margin: 15px;
  width: 750px;
  height: 430px;
}
.list-header {
  height: 40px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
